import React from "react";
import { connect } from "react-redux";
import Traec from "traec";

import { ErrorBoundary } from "storybook-dashboard/errors";
import BaseFormConnected from "traec-react/utils/form";

import { projectFields } from "AppSrc/project/form";
import { SetMetaDataFields } from "AppSrc/forms/meta";
import { setAndShowModal } from "AppSrc/utils/modal";
import { Spinner } from "traec-react/utils/entities";
import Im from "immutable";

// Define required meta fields (should match REQUIRED_FIELD_NAMES in forms/meta.js)
const REQUIRED_META_FIELDS = ["contract name"];

// Helper function to validate required fields
const validateRequiredFields = (meta, fields) => {
  const missingFields = [];

  // Get the list of field headers from input_details if available
  const inputFields = meta?.getIn(["input_details", "fields"]) || fields || Traec.Im.List();

  inputFields.forEach((field) => {
    const header = field?.get("header");

    if (!REQUIRED_META_FIELDS.includes(header?.toLowerCase())) {
      return;
    }
    const value = meta?.get(header);

    if (!value || (typeof value === "string" && value.trim() === "")) {
      missingFields.push(header);
    }
  });

  return missingFields;
};

export const setFetchBody = (post, company, meta) => {
  let styles = (company.getIn(["meta_json", "styles"]) || Traec.Im.Map()).toJS();

  post.company = { uid: company.get("uid") };
  post.meta_json = Traec.Im.isImmutable(meta) ? meta?.toJS() : {} || {};
  post.meta_json.syles = styles;

  let [templateTrackerId, templateProjectId] = (post.from_template || "").split(".");
  post.from_template = templateTrackerId || null;
  post.meta_json.from_template = templateTrackerId || null;

  if (!post.reporting_from_template) {
    post.reporting = {
      startDate: post.reporting_start,
      endDate: post.reporting_end,
      freq_unit: post.reporting_units,
      freq_num: post.reporting_freq,
    };
  } else {
    post.meta_json.setup_from_project = templateProjectId;
  }

  console.log("SENDING POST DATA", post);
  return post;
};

const getNewProjectMeta = (company, tenant_meta) => {
  let inputs =
    company?.getIn(["meta_json", "new_project_input_details"]) ||
    Traec.Im.fromJS(tenant_meta || Traec.Im.Map()).get("new_project_input_details") ||
    company?.getIn(["meta_json", "input_details"]);

  let meta = company?.get("meta_json") || Traec.Im.Map();

  return inputs ? meta?.set("input_details", inputs) : meta;
};

function ProjectSetupPending() {
  return (
    <div>
      <h3>Please be patient...</h3>
      <Spinner />
    </div>
  );
}

class CompanyProjectForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formFields: projectFields,
      setTemplateFields: false,
      templateCounter: 0,
      meta: getNewProjectMeta(props.company, props.tenant_meta),
      validationErrors: [], // Track validation errors for required fields
    };

    // Data required from the API for this Component
    this.requiredFetches = [
      new Traec.Fetch(
        "tracker",
        "list",
        {},
        {
          preUpdateHook: (args) => ({ ...args, onlyTemplates: true }),
        }
      ),
      new Traec.Fetch("company", "read"),
    ];
  }

  componentDidMount() {
    Traec.fetchRequiredFor(this);
  }

  componentDidUpdate() {
    let { templates } = this.props;
    let { setTemplateFields, templateCounter } = this.state;
    if (templates?.size && templates?.size != templateCounter) {
      console.log("Got new templates.size - updating list of templates");
      this.setFormTemplates();
    }
  }

  setFormTemplates() {
    let { templates, contract } = this.props;

    let _templates = templates;
    if (contract) {
      _templates = Im.fromJS(["Equipment", "Off-site", "Onsite"]);
    }

    let templateOptions = _templates
      .toList()
      .map((tracker, i) => (
        <option
          key={i}
          value={
            contract
              ? tracker.toLowerCase().replace("-", "")
              : `${tracker.get("uid")}.${tracker.getIn(["project", "uid"])}`
          }
        >
          {contract ? tracker : tracker.getIn(["project", "name"])}
        </option>
      ))
      .unshift(
        <option key={-1} value={""}>
          None
        </option>
      );

    projectFields.from_template.options = templateOptions;

    this.setState({
      setTemplateFields: true,
      templateCounter: templates?.size,
    });
  }

  setReportingDisabled(status) {
    if (this.props.contract) return null;
    projectFields.reporting_start.disabled = status;
    projectFields.reporting_end.disabled = status;
    projectFields.reporting_freq.disabled = status;
    projectFields.reporting_units.disabled = status;
  }

  render() {
    let { contract, company, tenant_meta, modalId, templates } = this.props;
    let { meta } = this.state;

    let fetch = new Traec.Fetch("project_and_setup", "post", {
      postTrackerSetupSuccessHook: (data) => {
        console.log("Got response from tracker setup. Waiting 7 seconds", data);
        setTimeout(function () {
          let projectId = data.project.uid;
          console.log("Redirecting to new created project", projectId);
          location.href = `/project/${projectId.substring(0, 8)}`;
        }, 2000);
      },
    });
    fetch.updateFetchParams({
      preFetchHook: (body) => {
        let _body = setFetchBody(body, company, meta);
        console.log("CompanyProjectForm sending setup payload", _body);
        return _body;
      },
      postSuccessHook: (data) => {
        $(`#${modalId}`).modal("hide");
        if (contract) {
          let companyId = data.contract_company_id;
          console.log("Redirecting to new contract company", companyId, data);
          location.href = `/company/${companyId.substring(0, 8)}`;
        }
      },
    });
    if (contract) {
      fetch._fetchParams.url = `/api/dashboard/company/${company.get("uid")}/project/setup`;
      fetch._fetchParams.nextHandlers = [];
    }

    let metaInputs =
      company?.getIn(["meta_json", "new_project_input_details"]) ||
      Traec.Im.fromJS(tenant_meta || Traec.Im.Map()).get("new_project_input_details") ||
      company?.getIn(["meta_json", "input_details"]);

    // remove project unnecessary fields if user is adding a contract
    let _projectFields = { ...projectFields };
    const projectFieldsToRemove = [
      "include_subcategories",
      "reporting_freq",
      "reporting_start",
      "reporting_end",
      "reporting_units",
      "reporting_from_template",
    ];

    if (contract) {
      projectFieldsToRemove.forEach((field) => {
        delete _projectFields[field];
      });
      _projectFields.name.label = "Supplier Name";
    } else {
      _projectFields.name.label = "";
    }

    return (
      <React.Fragment>
        <BaseFormConnected
          list="autocompleteOff"
          params={fetch.params}
          fields={_projectFields}
          forceShowForm={true}
          hideUnderline={true}
          prePostHook={(formData) => {
            // Validate required meta fields before form submission
            const missingFields = validateRequiredFields(meta, meta?.getIn?.(["input_details", "fields"]));

            if (missingFields.length > 0) {
              // Set validation errors in state
              this.setState({ validationErrors: missingFields });

              // Show alert to user
              alert(
                `Please fill in the following required field${missingFields.length > 1 ? "s" : ""}:\n- ${missingFields
                  .map((f) => f.charAt(0).toUpperCase() + f.slice(1))
                  .join("\n- ")}`
              );

              // Return false to block form submission
              throw new Error(
                `Please fill in the following required field${missingFields.length > 1 ? "s" : ""}:\n- ${missingFields
                  .map((f) => f.charAt(0).toUpperCase() + f.slice(1))
                  .join("\n- ")}`
              );
            }

            // Clear validation errors if all fields are valid
            this.setState({ validationErrors: [] });

            // Return true to allow form submission
            return formData;
          }}
          postChangeHook={(e) => {
            if (e.target.name == "reporting_from_template") {
              this.setReportingDisabled(e.target.children);
            }
            if (e.target.name == "from_template") {
              let is_set = !(e.target.value == null || e.target.value == "");
              if (_projectFields.reporting_from_template) {
                _projectFields.reporting_from_template.value = is_set;
              }
              this.setReportingDisabled(is_set);
            }
          }}
        />
        {!metaInputs ? null : (
          <ErrorBoundary>
            <hr />
            <div className="col-sm-12">
              {this.state.validationErrors.length > 0 && (
                <div className="alert alert-danger" role="alert">
                  <strong>Required fields missing:</strong>
                  <ul className="mb-0 mt-2">
                    {this.state.validationErrors.map((field, idx) => (
                      <li key={idx}>{field.charAt(0).toUpperCase() + field.slice(1)}</li>
                    ))}
                  </ul>
                </div>
              )}
              <SetMetaDataFields
                hideAdmin={true}
                hideSave={true}
                metaJson={meta}
                setMeta={(_meta) => {
                  // Clear validation errors when user updates the meta data
                  this.setState({ meta: _meta, validationErrors: [] });
                }}
              />
            </div>
          </ErrorBoundary>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { companyId } = ownProps;
  let company = state.getInPath(`entities.companies.byId.${companyId}`);
  let projects = company?.get(`projects`);
  // Get tracker templates
  let trackers = state.getInPath(`entities.trackers.byId`);
  let templates = trackers?.filter((item) => item.get("is_template"));
  let user = state.getInPath("auth.user");
  return { company, projects, templates, user };
};

export default connect(mapStateToProps)(CompanyProjectForm);
